import { getAuthState, getError, isLoading } from '/b2b/authentication/state/Auth.selectors';

import { onCompleteNewPassword } from './RecoverPassword.commands';

export const mapStateToProps = state => {
    return {
        authState: getAuthState(state),
        errorMesage: getError(state),
        isLoading: isLoading(state),
    };
};

export const mapDispatchToProps = { onCompleteNewPassword };
